import { getStore } from '~/mobx/AppStore';

const onClickSeeCandidates = () => {
    const { ballotStore } = getStore();

    ballotStore.setIsShownCandidates(true);
};

export default onClickSeeCandidates;
